import { useMutation } from "convex/react";
import { useState } from "react";
import { toast } from "sonner";
import { useAuthIdentity } from "@/contexts/UserProfileContext";
import { api } from "$convex/convexApi";

export type LogisticsReviewSection = "inbound" | "international" | "outbound";
export type LogisticsReviewStatus = Record<LogisticsReviewSection, { revision: number; needsReview: boolean }>;
export const LOGISTICS_REVIEW_PATHS: Record<string, LogisticsReviewSection> = {
	"/logistics/inbound-deliveries": "inbound",
	"/logistics/international-purchases": "international",
	"/logistics/outbound-shipments": "outbound",
};

export function LogisticsReviewControl({ section, revision, label }: {
	section: LogisticsReviewSection;
	revision: number;
	label: string;
}) {
	const { authUserId } = useAuthIdentity();
	const markReviewed = useMutation(api.logisticsReview.markReviewed);
	const [saving, setSaving] = useState(false);
	return <button
		type="button"
		className="ml-3 min-h-10 rounded-lg px-3 text-xs font-medium text-muted-foreground transition-colors hover:bg-background hover:text-foreground focus-visible:outline-2 focus-visible:outline-ring disabled:opacity-50"
		aria-label={`Mark ${label} reviewed`}
		disabled={saving}
		onClick={async () => {
			if (saving) return;
			setSaving(true);
			try {
				await markReviewed({ authUserId, section, revision });
			} catch {
				toast.error("Could not mark updates reviewed. Please try again.");
			} finally {
				setSaving(false);
			}
		}}
	>{saving ? "Saving…" : "Mark reviewed"}</button>;
}
